import { Part, PartProduct, ProductSpecTyres } from '@entities/Product';
import { getTextSeason } from '@entities/Product/module/helper/getTextSeason';
import { useAppSelector } from '@redux/hooks';
import { useRouter } from 'next/router';
import { getProductTypeText, getProductTypeUrl } from '../../helper/getProductTypeText';
import { getCategories, getProductBrand, getProductModel, getProductName, getProductSpecs, getProductType } from '../../selectors';

export const useBreadcrumbByProduct = () => {
  const { query } = useRouter();
  const breadcrumb = [];
  const brandData = useAppSelector(getProductBrand);
  const part = useAppSelector(getProductType);
  const model = useAppSelector(getProductModel);
  const category = useAppSelector(getCategories);
  const name = useAppSelector(getProductName);
  const typeProductName = getProductTypeText(part);
  const typeProductUrl = getProductTypeUrl(part);
  let brandUrl = brandData?.href || typeProductUrl + query?.brand;

  breadcrumb.push({ title: typeProductName, url: typeProductUrl });

  if (brandData?.name) {
    if (brandUrl.indexOf('?') === -1 && !brandUrl.endsWith('/')) {
      brandUrl += '/';
    }

    breadcrumb.push({ title: brandData?.name, url: brandUrl, external: true });
  }

  const specs = useAppSelector(getProductSpecs);
  const season = specs.find(x => x.title === ProductSpecTyres.Season);
  if (season) {
    const seasonText = getTextSeason(Number(season?.value));
    const seasonUrl = Number(season.value) === 1 ? '/zima/' : '/leto/';
    breadcrumb.push({ title: seasonText, url: brandUrl + seasonUrl });
  }

  if (
    ((query?.model && query?.brand) || model?.href) &&
    [Part.Batteries, Part.Secrets, PartProduct.Batteries, PartProduct.Secrets].indexOf(part) === -1
  ) {
    const modelUrl = query.model ? brandData?.href + '/' + query.model : model?.href;
    breadcrumb.push({ title: model?.name, url: modelUrl });
  }

  if (category.length) {
    category.forEach(item => {
      if (!breadcrumb.some(x => x.title === item?.name)) {
        breadcrumb.push({ title: item?.name, url: item?.url });
      }
    });
  }

  if (name) {
    breadcrumb.push({ title: name });
  }

  return breadcrumb;
};
